'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Yandex = function Yandex(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 24 24' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M11.732 11.689c.143-.535.249-.924.3-1.106.07-.243.455-1.438 1.208-3.753a599.235 599.235 0 0 0 1.214-3.739c.055-.273.293-.441.58-.441h1.51V3v-.35c.446 0 .607.368.482.718a8336.1 8336.1 0 0 0-2.217 6.05c-.945 2.583-1.626 4.456-1.97 5.416v5.848c0 .291-.211.523-.502.523h-1.396c-.314 0-.502-.23-.502-.523v-5.889c-.367-.925-.926-2.375-1.643-4.26l-.04-.103C8.123 8.768 6.698 5.002 6.696 5c-.16-.339.104-.757.496-.757h1.475c.36 0 .534.208.614.512.019.07.277.804 1.03 2.93a216.27 216.27 0 0 1 1.022 2.914l.4 1.09z'
      })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Yandex;